<script setup>
import { computed } from 'vue';

const props = defineProps({
  message: { type: Object, required: true },
  agentName: { type: String, default: 'AI' },
  agentInitials: { type: String, default: 'AI' },
  isStreaming: { type: Boolean, default: false },
});

const isUser = computed(() => props.message.role === 'user');
const isFailed = computed(() => props.message.status === 'failed');

const formatTime = dateStr => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
};
</script>

<template>
  <div
    class="flex gap-3"
    :class="isUser ? 'flex-row-reverse' : 'flex-row'"
  >
    <div v-if="!isUser" class="flex shrink-0 items-start pt-1">
      <div
        class="flex size-8 items-center justify-center rounded-full bg-gradient-to-br from-violet-500 to-indigo-600 text-xs font-bold text-white"
      >
        {{ agentInitials }}
      </div>
    </div>

    <div class="flex max-w-[75%] flex-col gap-1">
      <div
        class="rounded-2xl px-4 py-2.5 text-sm leading-relaxed"
        :class="[
          isUser
            ? 'rounded-tr-sm bg-gradient-to-br from-violet-600 to-indigo-600 text-white'
            : 'rounded-tl-sm bg-n-alpha-2 text-n-slate-12',
          isFailed ? 'opacity-60' : '',
        ]"
      >
        <div class="whitespace-pre-wrap break-words">
          {{ message.content }}<span
            v-if="isStreaming"
            class="ml-0.5 inline-block h-4 w-0.5 animate-pulse bg-violet-500"
          />
        </div>
      </div>
      <div
        class="flex items-center gap-1.5 px-1"
        :class="isUser ? 'justify-end' : 'justify-start'"
      >
        <span
          v-if="!isStreaming"
          class="text-[10px] text-n-slate-9"
        >
          {{ formatTime(message.created_at) }}
        </span>
        <span
          v-if="isStreaming"
          class="text-[10px] text-violet-500"
        >
          Recebendo...
        </span>
        <span
          v-else-if="isFailed"
          class="text-[10px] font-medium text-red-500"
        >
          Falhou
        </span>
        <span
          v-else-if="message.status === 'pending'"
          class="i-lucide-clock text-[10px] text-n-slate-9"
        />
      </div>
    </div>
  </div>
</template>
